(() => {
    const editorCallbacks = {
        addToBasket: function(saveToken, thumbnailUrl, settings) {
            const isSave = settings.product && settings.product.properties && (settings.product.properties.printessSaveToken || settings.product.properties._printessSaveToken);
            
            if(!isSave) {
                //Ad new product to cart
                let productId = Number(settings.product.Id || settings.product.id);

                if(settings.product.variants && settings.product.variants.length > 0) {
                    productId = Number(settings.product.variants[0].id);
                }

                if(window.printess && window.printess.implementation && window.printess.implementation.selectedVariant) {
                    productId = Number(window.printess.implementation.selectedVariant.id);
                }
    
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: "" + productId,
                                quantity: Number(document.querySelector('input[name="quantity"]').value) || 1,
                                properties: {
                                    _printessSaveToken: saveToken,
                                    _printessThumbnail: thumbnailUrl,
                                    _printessProductDefinitionId: "" + settings.productDefinitionId,
                                    _printessOutputType: settings.outputFormat || "pdf",
                                    _printessDpi: settings.outputDpi || "300"
                                },
                            },
                        ],
                    }),
                }).then(() => {
                    window.location.replace('/cart');
                });
            } else {
                fetch('cart/change.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      id: settings.product.key,
                      properties: {
                        _printessSaveToken: saveToken,
                        _printessThumbnail: thumbnailUrl,
                        _printessProductDefinitionId: "" + settings.product.properties._printessProductDefinitionId,
                        _printessOutputType: "" + settings.product.properties._printessOutputType,
                        _printessDpi: "" + settings.product.properties._printessDpi
                      },
                    }),
                  }).then(() => {
                    window.location.replace('/cart');
                  }).catch((e) => { alert(JSON.stringify(e)); });
            }
        },
        goBack: function(settings) {
            if(window.printess.editor) {
                window.printess.editor.hide();
            }
        },
        formFieldChanged: function(name, value, product) {
            if(window.printess.implementation) {
                window.printess.implementation.setFormFieldValue(name, value);

                window.printess.implementation.updateSelectedVariant(product.product);
            }
        }
    };

    if(!window.printess) {
        window.printess = {};
    }

    if(!window.printess.implementation) {
        window.printess.implementation = {
            parseName: (name) => {
                name = (name || "").trim();
            
                if(name) {
                  if(name[name.length - 1] === "]") {
                    name = name.substr(0, name.length - 1);
            
                    const index = name.indexOf("[");
            
                    if(index > -1) {
                      name = name.substr(index + 1);
                    }
                  }
                }
            
                return name;
            },
            getTemplateMergeJson: function(value) {
                if(!value) {
                    return null;
                }
                else if(typeof value === "string") {
                    try {
                        const ret = JSON.parse(value);

                        if(typeof ret === "string") {
                            return {
                                templateName: ret,
                                mergeMode: "layout-snippet-no-repeat"
                            };
                        } else {
                            if(!ret.mergeMode) {
                                ret.mergeMode = "layout-snippet-no-repeat";
                            }

                            return ret;
                        }
                    } catch(e) {
                        return {
                            templateName: value,
                            mergeMode: "layout-snippet-no-repeat"
                        };
                    }
                } else {
                    if(!value.mergeMode) {
                        return {...value, mergeMode: "layout-snippet-no-repeat"};
                    }

                    return value;
                }
            },
            showEditor: function(templateName, productDefinitionId, product, additionalSettings) {
                if(window.printess.editor) {
                    let settings = {};

                    if(product) {
                        settings = {'product': product, 'productDefinitionId': typeof productDefinitionId !== "undefined" && productDefinitionId !== null ? productDefinitionId  : -1};
                    }

                    if(additionalSettings) {
                        settings["outputFormat"] = additionalSettings["outputFormat"] || "pdf";
                        settings["outputDpi"] = additionalSettings["outputDpi"] || "300";
                    }

                    if(additionalSettings && additionalSettings["mergeTemplates"]) {
                        const mergeTemplates = window.printess.implementation.getTemplateMergeJson(additionalSettings["mergeTemplates"]);

                        if(mergeTemplates) {
                            settings["mergeTemplates"] = mergeTemplates;
                        }
                    }

                    if(additionalSettings && additionalSettings["formFields"] && additionalSettings["formFields"].length > 0) {
                        window.printess.implementation.selectedVariant = window.printess.implementation.getVariantByFormFields(product, additionalSettings["formFields"]);
                    }

                    window.printess.editor.show(templateName, additionalSettings ? (additionalSettings["formFields"] || []) : [], editorCallbacks, settings);
                }
            },
            getSelectedFormFields: () => {
                let inputs = window.document.querySelectorAll(`variant-selection > input[type="radio"]`);
                const formFields = [];

                if (inputs && inputs.length > 0) {          
                    inputs.forEach((el) => {
                        const selected = typeof el.checked !== "undefined" ? el.checked === true : el.getAttribute('checked') !== null;
                      
                        if (selected) {
                            const initialName = el.getAttribute('data-option-name') || el.getAttribute('name') || undefined;
                            const initialValue = el.getAttribute('value') || undefined;
                            formFields.push({ name: initialName, value: initialValue });
                        }
                    });
                }

                //In case select / drop down is used
                if(!inputs || inputs.length == 0) {
                    inputs = window.document.querySelectorAll(`variant-selection select`);

                    inputs.forEach((el) => {
                        const name = window.printess.implementation.parseName(el.getAttribute("name"));

                        if(el.options) {
                            for(let i = 0; i < el.options.length; ++i) {
                                const selected = el.options[i].selected !== "undefined" ? el.options[i].selected === true : ("" + el.options[i].getAttribute('selected') || "").toLowerCase() === "true";

                                if(selected) {
                                    formFields.push({ name: name, value: el.options[i].getAttribute('value') });
                                }
                            }
                        }
                    });
                }
            
                return formFields;
            },
            setFormFieldValue: (ffName, ffValue) => {
                let inputs = window.document.querySelectorAll(`variant-selection > input[type="radio"]`);

                if (inputs && inputs.length > 0) {          
                    inputs.forEach((el) => {
                        const initialName = el.getAttribute('data-option-name') || el.getAttribute('name') || undefined;
                        const initialValue = el.getAttribute('value') || undefined;

                        if(initialName === ffName && initialValue === ffValue) {
                            el.setAttribute('checked', true);
                            el.checked = true;
                        } else {
                            el.removeAttribute('checked');
                            el.checked = false;
                        }
                    });
                }

                //In case select / drop down is used
                if(!inputs || inputs.length == 0) {
                    inputs = window.document.querySelectorAll(`variant-selection select`);

                    inputs.forEach((el) => {
                        const name = window.printess.implementation.parseName(el.getAttribute("name"));

                        if(el.options) {
                            for(let i = 0; i < el.options.length; ++i) {
                                const value = el.options[i].getAttribute('value');

                                if(name === ffName && ffValue == value)
                                {
                                    el.setAttribute('selected', true);
                                    el.selected = true;
                                    el.setAttribute('value', value);
                                    el.value = value;
                                }
                                else
                                {
                                    el.removeAttribute('selected');
                                    el.selected = false;
                                }
                            }
                        }
                    });
                }
            },
            getVariantByFormFields: (product, formFieldValues) => {
                let ret = null;
                let variants = product.variants;

                if(product.variants && product.variants.length > 0 && formFieldValues && formFieldValues.length > 0) {
                    formFieldValues.forEach((ff) => {
                        variants = variants.filter((variant) => {
                            return variant.options.indexOf(ff.value) > -1;
                        });
                    });
                }

                if(variants && variants.length > 0) {
                    return variants[0];
                }

                return ret;
            },
            updateSelectedVariant: (product) => {
                window.printess.implementation.selectedVariant = window.printess.implementation.getVariantByFormFields(product, window.printess.implementation.getSelectedFormFields());
            }
        };
    }
})()